module.exports = __webpack_public_path__ + "static/media/google-paya.ed2f90ca.jpeg";